// componentes
import RemoveDraftConfirm from '@/components/modal/remove-draft-confirm';
import RemoveCompetition from '@/components/modal/remove-competition-confirm';
import RemoveQuotationRequestConfirm from '@/components/contractor/competitions/list/modal/remove-quotation-request-confirm.vue';
// Requisições
import { updateRatingLastSeen, getDrafts, getQuotations, getCanAnswerFeedback } from '@/services';
import { getQuotationsRequest } from '@/services/api/quotation';
// filtros
import { dateFilter } from '@/utils/filters';
// Módulos
import { mapState } from 'vuex';
export default {
    name: 'ListCompetitions',
    data: () => ({
        requestId: 0,
        ratingUserModal: false,
        removeCompetitionConfirmModal: false,
        removeQuotationRequestConfirm: false,
        removeDraftConfirmModal: false,
        competitionId: 0,
        draftId: 0,
        competitions: [],
        requests: [],
        drafts: [],
        userRatingForm: {
            rating: '',
            message: ''
        },
        disableSendRating: false,
        canAnswerFeedback: false
    }),
    components: {
        // RatingUser,
        RemoveDraftConfirm,
        RemoveCompetition,
        RemoveQuotationRequestConfirm
    },
    filters: {
        date: dateFilter
    },
    async created() {
        await this.getDrafts();
        await this.getQuotations();
        await this.getQuotationRequests();
    },
    methods: {
        openRequestRemovalConfirmation(requestId) {
            this.requestId = requestId;
        },
        removeCompetition() {
            this.competitions = this.competitions.filter(c => c.id != this.competitionId);
            this.competitionId = 0;
        },
        removeDraft() {
            this.drafts = this.drafts.filter(d => d.id != this.draftId);
            this.draftId = 0;
        },
        openCompetitionRemovalConfirmation(competitionId) {
            this.competitionId = competitionId;
            this.removeCompetitionConfirmModal = true;
        },
        openDraftRemovalConfirmation(draftId) {
            this.draftId = draftId;
            this.removeDraftConfirmModal = true;
        },
        goToCreateQuotationPage(draftId) {
            this.$router.push({
                name: 'NewCompetition',
                params: {
                    pageTitle: 'nova-cotacao',
                    isDraftEdit: true,
                    draftId: draftId
                }
            });
            // window.location.href =
            // 	"{{route('contractor-new-competition')}}?details=true&draft=true";
        },
        async getQuotationRequests() {
            if (this.verifyUserType.isCondoAdministrator || this.verifyUserType.isRequester)
                try {
                    const { results } = await getQuotationsRequest();
                    this.requests = results.map(request => {
                        const route = '/cotacao/' + request.id + '/propostas';
                        request.url = route;
                        return request;
                    });
                    this.filteredRequests = this.requests;
                } catch (error) {
                    console.error(error);
                }
        },
        goToQuotationDetailsPage(quotationId) {
            // Verificar essa rota :ENGELINK
            // let route = "{{route('contractor-competition-proposals', ['id' => '%id%'])}}";
            // route = route.replace('%id%', quotationId);
            // window.location.href = route;
        },
        async updateRatingLastSeen() {
            try {
                const data = {
                    lastTimeSeenFeedback: new Date()
                };
                await updateRatingLastSeen(data);
            } catch (error) {
                console.error(error);
            }
        },
        async getQuotations() {
            try {
                const { quotations } = await getQuotations();
                this.competitions = quotations.map(quotation => {
                    quotation.url = '/cotacao/' + quotation.id + '/propostas';
                    return quotation;
                });
            } catch (error) {
                console.error(error);
            }
        },
        async getDrafts() {
            try {
                const { drafts } = await getDrafts();
                this.drafts = drafts;
            } catch (error) {
                console.error(error);
            }
        },
        async getCanAnswerFeedback() {
            try {
                const { contractorLastSeen } = await getCanAnswerFeedback();
                this.canAnswerFeedback = contractorLastSeen.canAnswerFeedback;
            } catch (error) {
                console.error(error);
            }
        },
        goToQuotationRequest(id) {
            const routeData = this.$router.resolve({ name: 'CompetitionRequester', params: { id: id } });
            window.open(routeData.href, '_blank');
        }
    },
    computed: {
        ...mapState('user', ['user']),
        verifyUserType() {
            return this.user.type;
        }
    }
};
